import { Contexts, SchoolRoles, InstitutionRoles, OtherRoles, ROLE_ADMIN_RESEAU, ROLE_LOCAL_SECRETARY, ROLE_ADMIN_HOSPITAL_RO, ROLE_INTERNSHIP_MASTER_MACCS, ROLE_PRESI_MASTER, ROLE_CLINICAL_SECRETARY } from './constants'
import { isArray, isObject } from 'lodash'

export const isNurse = user => isValidUser(user) && user.roles.includes(InstitutionRoles.NURSE)

export const isObserver = user => isValidUser(user) && user.roles.includes(InstitutionRoles.OBSERVER)

export const isDomainEvaluator = user => isValidUser(user) && user.roles.includes(SchoolRoles.DOMAIN_EVALUATOR)

export const isSupervisor = user => isValidUser(user) && user.roles.includes(SchoolRoles.SUPERVISOR)

export const isValidator = user => isValidUser(user) && user.roles.includes(SchoolRoles.VALIDATOR)

export const isEncoder = user => isValidUser(user) && user.roles.includes(SchoolRoles.ENCODER)

export const isCoordinator = user => isValidUser(user) && user.roles.includes(SchoolRoles.COORDINATOR)

export const isHospitalAdmin = user => isValidUser(user) && user.roles.includes(InstitutionRoles.HOSPITAL_ADMIN)

export const isInstitutionGroupAdmin = user => isValidUser(user) && user.roles.includes(InstitutionRoles.INSTITUTION_GROUP_ADMIN)

export const isAdmin = user => isValidUser(user) && user.roles.includes(OtherRoles.ADMIN)

export const isStudent = user => isValidUser(user) && user.roles.includes(OtherRoles.STUDENT)

export const isSchoolUser = user => isValidUser(user) && user.context === Contexts.SCHOOL

export const isInstitutionUser = user => isValidUser(user) && user.context === Contexts.INSTITUTION

export const isSchoolMaccsUser = user => isValidUser(user) && user.context === Contexts.SCHOOL_MACCS

export const isInstitutionMaccsUser = user => isValidUser(user) && user.context === Contexts.INSTITUTION_MACCS

export const isAdminReseau = user => isValidUser(user) && user.roles.includes(ROLE_ADMIN_RESEAU)

export const isLocalSecretary = user => isValidUser(user) && user.roles.includes(ROLE_LOCAL_SECRETARY)

export const isAdminHospitalRO = user => isValidUser(user) && user.roles.includes(ROLE_ADMIN_HOSPITAL_RO)

export const isInternshipMasterMaccs = user => isValidUser(user) && user.roles.includes(ROLE_INTERNSHIP_MASTER_MACCS)

export const isPresiMaster = user => isValidUser(user) && user.roles.includes(ROLE_PRESI_MASTER)

export const isClinicalSecretary = user => isValidUser(user) && user.roles.includes(ROLE_CLINICAL_SECRETARY)

export const isAssistant = user => isValidUser(user) && user.roles.includes(OtherRoles.ASSISTANT)

export const isPremiumUser = user => isValidUser(user) && (
  (isSchoolUser(user) && user.school?.premium) ||
  (isInstitutionUser(user) && user.institutions[0]?.managed)
)

export const isValidUser = user => user && isObject(user) && isArray(user.roles)

export default {
  isNurse,
  isObserver,
  isDomainEvaluator,
  isSupervisor,
  isValidator,
  isEncoder,
  isCoordinator,
  isHospitalAdmin,
  isAdmin,
  isStudent
}
